import { PET_COUNTS } from 'shared/constants'
import { FilterSelector } from '../../presentations/FilterSelector'

interface PetsFilterContainerProps {
    open: boolean
    onOpen?: (event: any) => void
    onClose?: (event: any) => void
    onSelectedItemsChanged?: (event: any) => void
    initialSelectedItems: any[]
    propertyName?: string
}

export const PetsFilterContainer = (props: PetsFilterContainerProps): JSX.Element => {
    const {
        open,
        onOpen,
        onClose,
        propertyName,
        initialSelectedItems,
        onSelectedItemsChanged
    } = props

    return (
        <>
            <FilterSelector
                text={'Pets'}
                items={PET_COUNTS}
                open={open}
                propertyName={propertyName}
                onOpen={onOpen}
                onClose={onClose}
                initialSelectedItems={initialSelectedItems}
                onSelectedItemsChanged={onSelectedItemsChanged}
            />
        </>
    )
}